import { INK, SPINE_W, VB_H, VB_W } from '../timelineDiagramGeometry'
import { type TimelinePlacement } from '../timelineDiagramLayout'
import { ARROWHEAD_MARKER_URL, ArrowheadMarker } from './ArrowheadMarker'
import { BranchpointRises } from './BranchpointRises'
import { ForkBranches } from './ForkBranches'
import { JunctionNodeDots } from './JunctionNodeDots'
import { PerspectiveTracks } from './PerspectiveTracks'

// All the drawn ink of the diagram: the trunk + fork arms, the Plan A spine, the
// branchpoint rises, the perspective tracks, and the junction dots on top. Every
// line's position comes from the one PLACEMENT object passed in.
export const TimelineLines = ({ placement }: { placement: TimelinePlacement }) => (
  <svg
    viewBox={`0 0 ${VB_W} ${VB_H}`}
    preserveAspectRatio="xMidYMid meet"
    className="absolute inset-0 h-full w-full"
    aria-hidden="true"
  >
    <defs>
      <ArrowheadMarker />
    </defs>

    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <ForkBranches trunk={placement.trunk} forkPlans={placement.forkPlans} />
      {/* Plan A spine — runs full width; the Epilogue IS its right end, capped
          with an arrowhead just past the Epilogue label. */}
      <line {...placement.spine.line} stroke={INK} strokeWidth={SPINE_W} markerEnd={ARROWHEAD_MARKER_URL} />
      <BranchpointRises branchpoints={placement.branchpoints} />
      <PerspectiveTracks perspectives={placement.perspectives} />
    </g>

    <JunctionNodeDots
      branchpoints={placement.branchpoints}
      perspectiveForkNode={placement.perspectiveForkNode}
    />
  </svg>
)
